import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 360 164",
  fill: "none",
  preserveAspectRatio: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_1_143)\"><mask id=\"mask0_1_143\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"-91\" width=\"360\" height=\"280\"><rect y=\"-91\" width=\"360\" height=\"280\" fill=\"#D9D9D9\"></rect></mask><g mask=\"url(#mask0_1_143)\"><path d=\"M399.752 151.157L358.465 -45.9977L-49.8733 39.5127L-35.3219 109.001C16.2767 100.947 16.9349 130.482 70.1848 130.314C111.761 130.189 120.628 111.064 153.209 119.434C185.792 127.814 187.14 166.765 229.068 163.477C271.007 160.186 278.09 129.927 320.029 126.636C361.968 123.346 348.164 159.209 399.763 151.155\" fill=\"#4B291D\" style=\"\"></path><rect x=\"-5\" y=\"-35\" width=\"365\" height=\"111\" fill=\"#4B291D\"></rect></g></g><defs><clipPath id=\"clip0_1_143\"><rect width=\"360\" height=\"164\" fill=\"white\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }